export const OPTIONAL_NTH_USER_GUIDED_TOUR_ONBOARDING_STATE_KEYS = {
	tourSeenAt: 'optional-nth-user-guided-tour:tourSeenAt',
	hasDismissedTour: 'optional-nth-user-guided-tour:hasDismissedTour',
	hasCompletedTour: 'optional-nth-user-guided-tour:hasCompletedTour',
	hasSeenFinishNudge: 'optional-nth-user-guided-tour:hasSeenFinishNudge',
	isEnrolledAsNewUser: 'optional-nth-user-guided-tour:isEnrolledAsNewUser',
} as const;

export const OptionalNthUserGuidedTourOnboardingKeys = [
	...Object.values(OPTIONAL_NTH_USER_GUIDED_TOUR_ONBOARDING_STATE_KEYS),
] as const;
